// Per-frame viewport output (camera matrices, label anchors) goes to subscribers directly, not
// through React state: the label overlay and HUD update the DOM themselves on these.

import type { ViewportEvent } from './api.ts';

type Ev<K extends ViewportEvent['ev']> = Extract<ViewportEvent, { ev: K }>;
type Listener<K extends ViewportEvent['ev']> = (e: Ev<K>) => void;

const listeners = new Map<string, Set<(e: ViewportEvent) => void>>();

export function on<K extends ViewportEvent['ev']>(ev: K, fn: Listener<K>): () => void {
  const set = listeners.get(ev) ?? new Set();
  set.add(fn as (e: ViewportEvent) => void);
  listeners.set(ev, set);
  return () => set.delete(fn as (e: ViewportEvent) => void);
}

export function dispatch(e: ViewportEvent) {
  for (const fn of listeners.get(e.ev) ?? []) fn(e);
}

/** The last camera event, copied, for code that needs it outside a callback. */
export const lastCamera: { current: Ev<'camera'> | null } = { current: null };
on('camera', (e) => {
  lastCamera.current = { ...e, viewProj: new Float32Array(e.viewProj) };
});
